//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'paymentRule',
    methods: {
        enterTo() {
            window.location.href = `cmcchkhsh://prepaidCardValueAdded`
        }
    }
}



// WEBPACK FOOTER //
// ./src/page/paymentRule/index.vue